import React from "react";

// ── Shared word-sync engine (Karaoke Prompter + The Prompter word-sync mode) ──

export function estimateWordTimings(lines, { bpm, durationMs }) {
  const totalWords = lines.reduce((a, l) => a + l.line_text.split(/\s+/).filter(Boolean).length, 0);
  if (!totalWords) return lines;
  let wordMs;
  if (bpm) wordMs = Math.max(150, Math.round(60000 / bpm));
  else if (durationMs) wordMs = Math.max(150, Math.round(durationMs / totalWords));
  else wordMs = 380;
  let cursor = 0;
  return lines.map((l) => {
    const words = l.line_text.split(/\s+/).filter(Boolean);
    const wt = words.map((w) => {
      const t = { word: w, start_ms: cursor, end_ms: cursor + wordMs };
      cursor += wordMs;
      return t;
    });
    cursor += Math.round(wordMs / 2);
    return { ...l, word_timings: wt };
  });
}

export function linesFromText(text) {
  return (text || "")
    .split(/\n+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((line_text, line_index) => ({ line_index, line_text, word_timings: [] }));
}

export function totalDurationMs(lines) {
  let max = 0;
  lines.forEach((l) => (l.word_timings || []).forEach((w) => { if (w.end_ms > max) max = w.end_ms; }));
  return max;
}

export function currentLineIndex(lines, ms) {
  let idx = 0;
  for (let i = 0; i < lines.length; i++) {
    const wt = lines[i].word_timings || [];
    if (wt.length && wt[0].start_ms <= ms) idx = i;
  }
  return idx;
}

export const WordSyncDisplay = ({ lines, currentMs, fontSize = 40, mirrored = false }) => {
  const synced = lines.filter((l) => (l.word_timings || []).length);
  if (!synced.length) {
    return (
      <div className="text-ink-muted text-xl text-center px-8" data-testid="wordsync-empty">
        No timing yet — estimate from BPM/duration or tap-sync the words first.
      </div>
    );
  }
  const li = currentLineIndex(synced, currentMs);
  const line = synced[li];
  const next = synced[li + 1];
  return (
    <div className="text-center px-8" style={{ transform: mirrored ? "scaleX(-1)" : "none" }} data-testid="wordsync-display">
      <div className="font-display font-black leading-tight" style={{ fontSize: `${fontSize}px` }}>
        {(line.word_timings || []).map((w, i) => {
          const sung = currentMs >= w.end_ms;
          const current = currentMs >= w.start_ms && currentMs < w.end_ms;
          return (
            <span
              key={i}
              className={
                current
                  ? "text-brand-amber transition-colors duration-100"
                  : sung
                  ? "text-white transition-colors duration-150"
                  : "text-white/25 transition-colors duration-150"
              }
            >
              {w.word}{" "}
            </span>
          );
        })}
      </div>
      {next && (
        <div className="mt-6 text-white/20 font-semibold" style={{ fontSize: `${Math.round(fontSize * 0.45)}px` }} data-testid="wordsync-next-line">
          {next.line_text}
        </div>
      )}
    </div>
  );
};
